import type { SVGProps } from '@integrations/react'
import { uiSize } from '@utils'

interface Props extends Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> {
  /** Rendered width and height in px; `null` leaves sizing to the host's CSS. */
  size?: number | null
}

function CryptoIcon({ size = 14, strokeWidth = 2, ...props }: Props) {
  return (
    <svg
      width={uiSize(size)}
      height={uiSize(size)}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      aria-hidden='true'
      {...props}
    >
      <circle cx='12' cy='12' r='9' />
      <path d='M9.5 8h4a2 2 0 0 1 0 4h-4zm0 4h4.5a2 2 0 0 1 0 4H9.5zM9.5 7v10M11.5 6v2M11.5 16v2' />
    </svg>
  )
}

export default CryptoIcon
